import { authenticationService } from '../../../webportal/services/authentication';
import * as React from 'react';
import { bindObjectMethods } from '../../../webportal/utils/utilFunctions';
import { backOfficeSignUpSites } from '../../utils/constants';
import { renderLucidLinkLogo } from '../../../webportal/components/common/Icons';

interface LoginState {
    loading: boolean;
}

class Login extends React.Component<any, LoginState> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
        };

        bindObjectMethods(this, Login.prototype);
    }

    render() {
        const alternateSignUps =  <span key={backOfficeSignUpSites.name}>{backOfficeSignUpSites.component(authenticationService.login)}</span>;
        return (
            <div className="login">
                <main>
                    {renderLucidLinkLogo()}
                    {alternateSignUps}
                </main>
            </div>
        );
    }

}

export { Login };



// WEBPACK FOOTER //
// ./src/backoffice/components/authentication/Login.tsx